const contractsRadio = [
  {
    label: 'Standard Contract',
    info:
      'lorem ipsum dolor sit amet lorem ipsum lorem lorem lorem ipsum dolor sit amet lorem ipsum',
  },
  {
    label: 'Contract',
    info: 'contract',
  },
];

const createTokenSteps = [
  {
    stepId: 1,
    title: 'common.name',
  },
  {
    stepId: 2,
    title: 'common.symbol',
  },
  {
    stepId: 3,
    title: 'common.icon',
  },
  {
    stepId: 4,
    title: 'common.short_description',
  },
  {
    stepId: 5,
    title: 'common.contract',
  },
  {
    stepId: 6,
    title: 'new_token.total_supply',
  },
];

const createCouponSteps = [
  {
    stepId: 1,
    title: 'common.name',
  },
  {
    stepId: 2,
    title: 'new_coupon.headline',
  },
  {
    stepId: 3,
    title: 'common.symbol',
  },
  {
    stepId: 4,
    title: 'common.short_description',
  },
  {
    stepId: 5,
    title: 'common.icon',
  },
  {
    stepId: 6,
    title: 'common.contract',
  },
  {
    stepId: 7,
    title: 'new_coupon.total_coupon',
  },
];

const createCrowdsaleSteps = [
  {
    stepId: 1,
    title: 'common.name',
  },
  {
    stepId: 2,
    title: 'common.icon',
  },
  {
    stepId: 3,
    title: 'new_crowdsale.campaign_date',
  },
  {
    stepId: 3,
    title: 'new_crowdsale.campaign_date',
  },
  {
    stepId: 4,
    title: 'common.short_description',
  },
  {
    stepId: 5,
    title: 'common.contract',
  },
  {
    stepId: 5,
    title: 'new_token.type',
  },
  {
    stepId: 6,
    title: 'new_crowdsale.item_to_sell',
  },
  {
    stepId: 6,
    title: 'new_crowdsale.max_supply',
  },
  {
    stepId: 7,
    title: 'new_crowdsale.give_ratio',
  },
  {
    stepId: 7,
    title: 'asset_popup.token',
  },
];

const createPickupbasketSteps = [
  {
    stepId: 1,
    title: 'common.name',
  },
  {
    stepId: 2,
    title: 'common.icon',
  },
  {
    stepId: 3,
    title: 'common.short_description',
  },
  {
    stepId: 4,
    title: 'new_pickupbox.product_available',
  },
  {
    stepId: 4,
    title: 'new_pickupbox.coupon_to_give',
  },
];

const languages = [
  {
    title: 'italian',
    code: 'it',
  },
  {
    title: 'german',
    code: 'de',
  },
  {
    title: 'english',
    code: 'en',
  },
  {
    title: 'greece',
    code: 'el',
  },
  {
    title: 'french',
    code: 'fr',
  },
];

export { contractsRadio, createTokenSteps, languages, createCouponSteps, createCrowdsaleSteps, createPickupbasketSteps };
